import { motion } from "framer-motion";
import { useT } from "../i18n/LanguageContext";

export default function AnnouncementBanner() {
    const { t } = useT();
    return (
        <div
            className="relative z-50 bg-gold text-charcoal overflow-hidden"
            data-testid="announcement-banner"
        >
            <div className="flex whitespace-nowrap animate-marquee py-2 text-[11px] tracking-[0.3em] uppercase font-semibold">
                {Array.from({ length: 8 }).map((_, i) => (
                    <motion.span
                        key={i}
                        className="mx-8 inline-flex items-center gap-3"
                    >
                        <span className="inline-block w-1.5 h-1.5 rounded-full bg-charcoal" />
                        {t("banner.text")}
                        <span className="text-charcoal/60">·</span>
                        {t("banner.wynwood")}
                    </motion.span>
                ))}
            </div>
        </div>
    );
}
